<template>
  <v-dialog
    v-model="show"
    max-width="700px"
    persistent>
    <div class="muted">
      <div
        class="d-flex align-center justify-space-between primary muted-immutable--text fill-width px-6"
        style="height: 60px;">
        <div
          class="d-flex align-center">
          <span
            class="muted-immutable--text font-weight-bold ui-text-xl">
            Relatório exportado com sucesso!
          </span>
        </div>
        <v-icon
          size="26"
          color="muted"
          @click="show = false">
          mdi mdi-close
        </v-icon>
      </div>

      <div
        class="d-flex flex-row align-center pa-6">
        <v-icon
          color="success"
          size="18">
          far fa-check-circle
        </v-icon>
        <span
          class="ml-2 foreground--text">
          Você pode acessá-lo a qualquer momento na aba "Meus Relatórios".
        </span>
      </div>

      <v-divider />

      <div
        class="d-flex justify-end gap-h-10 pa-6">
        <v-btn
          color="primary"
          outlined
          @click="close">
          Fechar
        </v-btn>
        <v-btn
          class="muted-immutable--text"
          color="primary"
          @click="goToReportPage">
          Ir para Meus Relatórios
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReportExportedModal',
  data: () => ({ show: false }),
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.$emit('closed');
    },
    goToReportPage() {
      this.$emit('goToReport');
      this.show = false;
    },
  },
};
</script>
